module.exports = ['nl-BE', 'nl-NL', 'en-US', 'fr-BE', 'fr-FR', 'de-DE'];
